import { WithStatePaginatedTable } from '@delmonicos/shared-design-system-react/src/components/with-state-paginated-table/with-state-paginated-table';
import { TransformedPaginatedData } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/transform-api-paginated-response/transformed-paginated-data.model';
import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import {
  ColumnOrderState,
  OnChangeFn,
  SortingState,
  VisibilityState,
} from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { StateEnum } from '@model/enum/state.enum';

import {
  EMSP_BO_CHARGING_SESSION_LIST_COLUMN_LIST,
  EMSP_BO_CHARGING_SESSION_LIST_COLUMN_ORDER,
  EMSP_BO_CHARGING_SESSION_LIST_COLUMN_VISIBILITY,
} from './emsp-bo-charging-session-list.config';

interface EmspBoChargingSessionListViewProps {
  paginationLimit: number;
  paginationLimitList: number[];
  paginationState: StateEnum;
  paginationSorting: SortingState;
  resource?: TransformedPaginatedData<GatewayChargingSessionModel>;
  columnVisibility?: VisibilityState;
  columnOrder?: ColumnOrderState;
  onPaginationLimitChange: (paginationLimitNext: number) => void;
  onPaginationPageChange: (paginationPageNext: number) => void;
  onPaginationSortingChange?: OnChangeFn<SortingState>;
  renderColumnSettings?: (close: () => void) => React.ReactNode;
  onHideColumn?: (columnId: string) => void;
  onColumnOrderChange?: OnChangeFn<ColumnOrderState>;
}

export const EmspBoChargingSessionListView = ({
  paginationLimit,
  paginationLimitList,
  paginationState,
  paginationSorting,
  resource,
  columnVisibility = EMSP_BO_CHARGING_SESSION_LIST_COLUMN_VISIBILITY,
  columnOrder = EMSP_BO_CHARGING_SESSION_LIST_COLUMN_ORDER,
  onPaginationLimitChange,
  onPaginationPageChange,
  onPaginationSortingChange,
  renderColumnSettings,
  onHideColumn,
  onColumnOrderChange,
}: EmspBoChargingSessionListViewProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <WithStatePaginatedTable
      paginatedData={resource}
      state={paginationState}
      sorting={paginationSorting}
      columns={EMSP_BO_CHARGING_SESSION_LIST_COLUMN_LIST}
      columnOrder={columnOrder}
      columnVisibility={columnVisibility}
      limit={paginationLimit}
      limitList={paginationLimitList}
      errorMessage={t('$.emsp-bo-charging-session-list.error')}
      onLimitChange={onPaginationLimitChange}
      onPageChange={onPaginationPageChange}
      onSortingChange={onPaginationSortingChange}
      renderColumnSettings={renderColumnSettings}
      onHideColumn={onHideColumn}
      onColumnOrderChange={onColumnOrderChange}
    />
  );
};
